import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ManualInventoryActionsView } from "src/components/views/erp/warehouse/inventory/manualEventViews/ManualInventoryActionsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/warehouse/inventory/manualEvents")({
	staticData: { title: i18n.t("warehouse_actions"), legacyViewKey: "manualInventoryEventButtonsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ManualInventoryActionsView />;
}
